import { ErrorFallback } from '../components/molecules/error-fallback';
/**
 * Errore di una route, per web e backoffice: senza `defaultErrorComponent`
 * TanStack Router mostra il suo «Something went wrong!» in inglese; qui la
 * pagina tradotta con «Ricarica pagina», la stessa del limite d'errore
 * dell'app.
 */
export const ROUTER_ERROR_OPTIONS = {
    defaultErrorComponent: ErrorFallback,
};
//# sourceMappingURL=router-error-options.js.map